import {
    Loading,
    Message
} from 'element-ui';
import $store from '@/store/index.js';

//Loading
const loading = (v, i, r) => {
    const lo = Loading.service({
        lock: true,
        text: v || "Loading...",
        spinner: i || 'el-icon-loading',
        background: r || 'rgba(0, 0, 0, 0.7)'
    });
    return lo;
};

//Message
const message = (v, t, e) => {
    Message({
        message: v,
        type: ((!t && !e) ? "success" : ((t == 1 ? "success" : (t == 2 ? "warning" : (t == 3 ? "error" : ""))))),
        onClose: function() {
            e && e();
        }
    });
};

const getDate = (v) => {
    if (!v) return;
    return new Date(v.replace(/-/g, "/"));
};

//系统时间
const systemDate = () => {
    var addzero = (value) => {
        return (value < 10 ? ('0' + value) : value);
    };

    // let time = new Date($store.state.newDate),
    let time = new Date(),
        data = {},
        y = time.getFullYear(),
        m = time.getMonth() + 1,
        d = time.getDate(),
        hh = time.getHours(),
        mm = time.getMinutes(),
        ss = time.getSeconds(),
        day = time.getDay(),
        yt = y + '-' + addzero(m),
        yts = (m == 12 ? y + 1 : y) + '-' + addzero(m == 12 ? 1 : m + 1),
        ytss = (m == 12 ? y + 1 : y) + '-' + addzero(m - 10 > 0 ? m - 10 : m + 2) + '-01 00:00:00',
        ytd = y + '-' + addzero(m) + '-' + addzero(d),
        ytds = y + '-' + addzero(m) + '-' + addzero(d) + ' 00:00:00',
        ytde = y + '-' + addzero(m) + '-' + addzero(d) + ' 23:59:59',
        ytdhms = y + '-' + addzero(m) + '-' + addzero(d) + ' ' + addzero(hh) + ':' + addzero(mm) + ':' + addzero(ss);
    let _yts = timestamp(getDate(ytss).getTime() - 86400000)['YTDe'];

    data['YT'] = yt;
    data['YTS'] = yts;
    data['YTSS'] = _yts;
    data['YTD'] = ytd;
    data['YTDs'] = ytds;
    data['YTDe'] = ytde;
    data['YTDhms'] = ytdhms;
    data['day'] = day;
    return data;
};

//时间戳
const timestamp = (v = new Date().getTime()) => {
    var addzero = (value) => {
        return (value < 10 ? ('0' + value) : value);
    };
    let time = new Date(v),
        data = {},
        y = time.getFullYear(),
        m = time.getMonth() + 1,
        d = time.getDate(),
        hh = time.getHours(),
        mm = time.getMinutes(),
        ss = time.getSeconds(),
        yt = y + '-' + addzero(m),
        ytd = y + '-' + addzero(m) + '-' + addzero(d),
        ytds = y + '-' + addzero(m) + '-' + addzero(d) + ' 00:00:00',
        ytde = y + '-' + addzero(m) + '-' + addzero(d) + ' 23:59:59',
        ytdhms = y + '-' + addzero(m) + '-' + addzero(d) + ' ' + addzero(hh) + ':' + addzero(mm) + ':' + addzero(ss),
        ytss = (m >= 11 ? y + 1 : y) + '-' + addzero(m - 10 > 0 ? m - 10 : m + 2) + '-01 00:00:00';
    data['hh'] = hh;
    data['YT'] = yt;
    data['YTD'] = ytd;
    data['YTDs'] = ytds;
    data['YTDe'] = ytde;
    data['YTDhms'] = ytdhms;
    data['YTSS'] = ytss;
    data['timeTogether'] = y * 10000 + m * 100 + d;
    return data;
};

//活动倒计时etime结束时间startTime开始显示倒计时显示器时间
const timeDown = (sTime, etime) => {
    var addzero = (value) => {
        return (value < 10 ? ('0' + value) : value);
    };
    //结束时间
    let _e = new Date(etime).getTime(),
        //当前时间
        _s = new Date().getTime(),
        // _s = $store.state.newDate,
        //倒计时总时间
        _d = (_e - _s) / 86400000,
        _h = (_d - Math.trunc(_d)) * 24,
        _m = (_h - Math.trunc(_h)) * 60,
        _ss = (_m - Math.trunc(_m)) * 60,
        _D = Math.trunc(_d),
        _H = Math.trunc(_h),
        _M = Math.trunc(_m),
        _S = Math.trunc(_ss),
        //开始显示倒计时时间
        _show = sTime ? _s <= _e : false;

    return {
        day: addzero(_D),
        hh: addzero(_H),
        mm: addzero(_M),
        ss: addzero(_S),
        show: _show
    }
}

//setCookie
const setCookie = (v) => {
    window.document.cookie = v.setName + "=" + v.setValue + ";path=/;expires=" + v.setDate;
}

//getCookie
const getCookie = (v) => {
    var arr, reg = new RegExp("(^| )" + v + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) {
        return unescape(arr[2]);
    } else {
        return null;
    }
}

//clearCookieName
const clearCookie = (v) => {
    setCookie(v, "", -1);
}

//判断数据类型
const getDataType = (v) => {
    let _result = Object.prototype.toString.call(v),
        _str = _result.replace("\[", "").replace("\]", "")
    return _str.split(' ')[1];
}

/**
 * 将以base64的图片url数据转换为Blob
 * 用url方式表示的base64图片数据
 */
const convertBase64UrlToBlob = (urlData) => {
    var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
    //处理异常,将ascii码小于0的转换为大于0
    var ab = new ArrayBuffer(bytes.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
    }
    return new Blob([ab], {
        type: 'image/png'
    });
}

// 将base64转换成file对象
const dataURLtoFile = (dataurl, filename = 'file') => {
    let arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        suffix = mime.split('/')[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    //不兼容IE
    return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
    })
}

//将base64转换为file文件（兼容IE11）
const blobToFile = (dataurl, filename = 'file') => {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n),
        suffix = mime.split('/')[1]
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    let theBlob = new Blob([u8arr], { type: mime });
    // theBlob.lastModifiedDate = new Date($store.state.newDate);
    theBlob.lastModifiedDate = new Date();
    theBlob.name = `${filename}.${suffix}`;
    return {
        file: theBlob,
        name: `${filename}.${suffix}`
    };
}

//发货日期禁用日期time 日期时间，disables 假期时间戳数组，two 今天起最少禁用天数，max 下个月尾（22点为天数跨度节点）
const disableDate = (time, disables = [], min) => {
    let _return,
        // {YTDs, YTSS} = timestamp($store.state.newDate),
        { YTDs, YTSS } = timestamp(),
        _sTime = getDate(YTDs).getTime(),
        _minDay = min == 99 ? 2 : min,
        _min = _sTime + _minDay * 86400000;

    //升序防止数据顺序错乱
    if (disables.length > 0) {
        disables.sort();
        disables.forEach(item => {
            //禁用假期
            _return = _return || time == item;
            //最小禁用日期
            if (item > _sTime && item <= _min) {
                _min += 86400000;
            }
        });
    }

    /**
     * @2020-10-23
     * 判断三天内的周日禁用
     * 有可能3天以下所以用循环判断三天内的周日禁用
     */
    if (min <= 3) {
        for (let i = min; i <= 3; i++) {
            let _time = _sTime + i * 86400000;
            if (new Date(_time).getDay() == 0) {
                //禁用
                _return = _return || time == _time;
            }
        }
    }

    /**
     * 2020/09/22
     * 保留
     */
    // if(min >= 4) {
    //   for(let i = 0; i < (_min - _sTime) / 86400000; i++) {
    //     if(new Date(_sTime + i * 86400000).getDay() == 0) {
    //       _min -= 86400000;
    //       break;
    //     }
    //   };
    //   //将假期倒序后往前计算是否在假期内
    //   disables.reverse();
    //   disables.forEach(item => {
    //     if(item == _min) {
    //       _min -= 86400000;
    //     }
    //   });
    // }

    _return = _return || time < _min || time >= getDate(YTSS).getTime();
    return _return;
}

//根据天数回显选中的日期disables 假期时间戳数组，days （22点为天数跨度节点）
const echoDate = (disables, days, minDay) => {
    // let {YTDs} = timestamp($store.state.newDate),
    let { YTDs } = timestamp(),
        _sTime = getDate(YTDs).getTime(), //当前系统时间
        _eTime = _sTime + days * 86400000,
        _minDay = minDay == 99 ? 2 : minDay,
        _min = _sTime + _minDay * 86400000;

    //升序防止数据顺序错乱
    disables.sort();
    (disables || []).forEach(item => {
        //选中的日期之前存在假期的累加一天
        if (item > _sTime && item <= _eTime) {
            _eTime += 86400000;
        }
        // //通过假期计算最小可选日期天数
        // if(item > _sTime && item <= _min) {
        //   //若最小禁用天数内还存在假期的加一天后再计算（以此类推）
        //   _min += 86400000;
        // }
    })

    /**
     * 2020/09/22
     * 保留
     */
    // //minDay >= 4判断最小日期内存在星期日往前计算一天
    // if(minDay >= 4) {
    //   for(let i = 0; i < (_min - _sTime) / 86400000; i++) {
    //     if(new Date(_sTime + i * 86400000).getDay() == 0) {
    //       _eTime -= 86400000;
    //       break;
    //     }
    //   }

    // //将假期倒序后往前计算是否在假期内
    // disables.reverse();
    // disables.forEach(item => {
    //   if(item == _eTime) {
    //     _eTime -= 86400000;
    //   }
    // });
    // }

    return timestamp(_eTime).YTDs;
}

//计算选中日期后得到天数（22点为天数跨度节点）
const getDays = (day, disables = [], minDay) => {
    if (day) {
        let _dayTime = getDate(timestamp(day).YTDs).getTime(), //日期选中的日期
            // _newTime = $store.state.newDate,
            _newTime = new Date().getTime(),
            _sTime = getDate(timestamp(_newTime).YTDs).getTime(), //当前系统日期
            _sumDay = (_dayTime - _sTime) / 86400000, //当前日期到选中日期的天数（未扣去假期的天数）
            _minDay = minDay == 99 ? 2 : minDay,
            _min = _sTime + _minDay * 86400000; //初始计算最小天数

        console.log(_sumDay);
        //升序防止数据顺序错乱
        disables.sort();
        //扣去假期天数
        (disables || []).forEach(item => {
            if (item > _sTime && item < _dayTime) {
                //位于当前日期到选中日期之间则间隔天数去除一天
                --_sumDay;
            }
            // if(item > _sTime && item <= _min) {
            //   //若最小禁用天数内还存在假期的加一天后再计算（以此类推）
            //   _min += 86400000;
            // }
        });

        /**
         * 2020/09/22
         * 保留
         */
        // if(minDay >= 4) {
        //   //判断禁用日期内是否存在不属于假期的星期日
        //   for(let i = 0; i < (_min - _sTime) / 86400000; i++) {
        //     if(new Date(_sTime + i * 86400000).getDay() == 0) {
        //       ++_sumDay;
        //       break;
        //     }
        //   }
        // }

        //若选择的天数小于最小计算天数按最小计算天数计算
        return _sumDay > minDay || minDay == 99 ? _sumDay : minDay;
    } else {
        return null;
    }
}

//数组排序
const arraySort = (arr, len) => {
    for (var i = 0; i < len; i++) {
        for (var j = 0; j < len - 1 - i; j++) {
            if (Number(arr[j]["x1"]) > Number(arr[j + 1]["x1"])) {
                var temp = arr[j + 1];
                arr[j + 1] = arr[j];
                arr[j] = temp;
            }
        }
    }
}

//画布绘制 nodeId：canvas节点，data：识别返回的字体坐标数据，imgUrl：canvas图片路径；coordinate：接口返回的字体数据；type：1主页面2弹出框，event：点击字体事件, valuation: 计价
const setCanvas = (nodeId, data, imgUrl, coordinate, inputHeight, imgHeight, type, fontClick, valuation) => {
    var canvas = nodeId.getContext("2d"),
        img = new Image(),
        red = "rgba(255, 0, 0, 1)",
        green = "#02C402",
        blue = "#0092FF",
        fontStyle = "20pt Calibri",
        kgTypeArrays = []; //计价字体

    if (!nodeId.getContext) return;

    return new Promise((resolve, reject) => {
        //解决图片跨域问题
        img.setAttribute("crossOrigin", "Anonymous");
        img.src = imgUrl;

        img.onload = function() {

            nodeId.height = img.height * (1200 / img.width);
            nodeId.width = 1200;
            let _WH = document.documentElement.clientHeight - 150,
                _scale = false,
                _r = 1;

            if (nodeId.height > _WH) {
                _scale = true;
                nodeId.height = img.height;
                nodeId.width = img.width;
            }
            _r = _scale ? 1 : 1200 / img.width; //比例

            canvas.drawImage(img, 0, 0, nodeId.width, nodeId.height);
            //排序
            arraySort(data, data.length);

            for (let _i = 0, _len = data.length; _i < _len; _i++) {
                canvas.font = fontStyle;
                canvas.fillStyle = red;
                canvas.strokeStyle = red;
                nodeId.globalAlpha = 1;
                let {
                    x1: _x1,
                    x2: _x2,
                    y1: _y1,
                    y2: _y2,
                    type: _type,
                    id: _ID,
                    overallSituation: _overallSituation,
                    thickeningNumber: _thickeningNumber,
                    imgHeightIndex: _imgHeightIndex,
                    fileUrl: _fileUrl,
                    name: _name
                } = data[_i];

                //主页面
                if (coordinate) {
                    if (getDataType(coordinate) === "Array" && coordinate.length > 0) {
                        //字体变绿
                        let { id: _id, thickeningNumber: _thickeningNumber } = coordinate[_i];
                        if (_id && _id.length > 0 || _thickeningNumber) {
                            canvas.fillStyle = green; //字体编号颜色
                            canvas.strokeStyle = green; //边框颜色
                        }
                    }
                    //对应下标变蓝色
                    if (getDataType(coordinate) === "Object") {
                        if (coordinate[_i]) {
                            //蓝色
                            canvas.fillStyle = blue;
                            canvas.strokeStyle = blue;
                        }
                    }
                }
                //计价字体信息
                if (valuation && imgHeight && inputHeight) {
                    var _W = _x2 - _x1,
                        _H = _y2 - _y1,
                        _imgW = parseFloat((_W / imgHeight) * inputHeight).toFixed(2),
                        _imgH = parseFloat((_H / imgHeight) * inputHeight).toFixed(2),
                        kgTypeArray = {
                            high: _imgH,
                            width: _imgW,
                            type: _type,
                            id: _ID && _ID.length > 0 ? _ID : [],
                            overallSituation: _overallSituation,
                            imgHeight: imgHeight,
                            inputHeight: parseFloat(inputHeight).toFixed(2),
                            thickeningNumber: _thickeningNumber,
                            imgHeightIndex: _imgHeightIndex,
                            fileUrl: _fileUrl || "",
                            name: _name || "",
                            x1: _x1,
                            x2: _x2,
                            y1: _y1,
                            y2: _y2
                        };
                    kgTypeArrays.push(kgTypeArray);
                    //输入的高度对应的字体颜色标注
                    // if(_imgH && _imgH == parseFloat(inputHeight).toFixed(2) && _imgHeightIndex){
                    //   canvas.fillStyle = "#02C402";
                    // }
                }

                let _index = type === 1 ? _i : data[_i].index || _i;
                canvas.fillText(_index + 1, _x1 * _r, _y1 * _r);
                canvas.strokeRect(_x1 * _r, _y1 * _r, (_x2 - _x1) * _r, (_y2 - _y1) * _r);

                if (inputHeight && imgHeight) {
                    //计算每个字体宽高并绘制
                    setFontWH(canvas, _x1, _y1, _x2, _y2, _r, inputHeight, imgHeight);
                }
            }

            //字体点击
            nodeId.onclick = function(e) {
                fontClick && fontClick(e, _r);
            }

            //计价
            if (valuation && imgHeight && inputHeight) {
                valuation && valuation(kgTypeArrays);
            }
            resolve(_r);
        }
    })
}

//点击canvas字体e：点击位置信息， data： 字体信息，r：字体比例，getFonts：选中的字体
const canvasClick = (e, data, r, getFonts) => {
    var check = false;
    for (let i = 0, len = data.length; i < len; i++) {
        let { x1, x2, y1, y2 } = data[i], { offsetX, offsetY } = e,
            _pitch = x2 * r > offsetX && offsetX > x1 * r && y2 * r > offsetY && offsetY > y1 * r;

        if (_pitch) {
            check = true;
            var _ensure = true;
            for (let _i = 0, len = getFonts.length; _i < len; _i++) {
                if (getFonts[_i].index == i) {
                    _ensure = false;
                    getFonts.splice(_i, 1);
                    break;
                }
            }
            if (_ensure) {
                getFonts.push(data[i]);

                let { thickeningNumber, id, overallSituation } = data[i],
                    _id = id && id.length > 0;

                getFonts.forEach(n => {
                    n['index'] = n.index != undefined ? n.index : i;
                    n['thickeningNumber'] = thickeningNumber ? true : false;
                    n['overallSituation'] = _id || thickeningNumber ? overallSituation || "0" : "";
                    n['id'] = _id ? id : [];
                });
            }
            break;
        }
    }
    return check;
}

//画布字体根据比例计算高度
const setFontWH = (canvas, x1, y1, x2, y2, r, iH, Fr) => {
    var W = x2 - x1,
        H = y2 - y1,
        Wr = W * r,
        Hr = H * r,
        FW = parseFloat((W / Fr) * iH).toFixed(2), //字体宽
        FH = parseFloat((H / Fr) * iH).toFixed(2), //字体高
        FWr = parseFloat((Wr / Fr) * iH).toFixed(2), //比例宽
        FHr = parseFloat((Hr / Fr) * iH).toFixed(2), //比例高
        Fs = '12pt Calibri', //字体大小类型
        Fc = '#02aaff' //字体颜色

    //7.5为偏移量
    canvas.font = Fs;
    canvas.fillStyle = Fc;
    canvas.fillText(FW, Wr / 2 + Number(x1 * r) - canvas.measureText(FWr).width / 2, Number(y1 * r) + 7.5);
    canvas.fillText(FH, Number(x1 * r) - canvas.measureText(FHr).width / 2, Hr / 2 + Number(y1 * r) + 7.5);
}

//输入高度确认后计算字体信息allFonts: 所有字体，getFonts：选中的字体
const alterFonts = (allFonts, getFonts) => {
    console.log(allFonts)
        //没有设置的字体信息
    if (!getFonts || getFonts.length <= 0) return;

    let [{ overallSituation, id } = {}, ] = getFonts

    allFonts.forEach((n, i) => {
        //全局
        if (overallSituation == 1) {
            getFonts.forEach(c => {
                if (c.index == i) {
                    n["fileUrl"] = c.fileUrl || "";
                    n["name"] = c.name || "";
                    n["id"] = id || [];
                    n["thickeningNumber"] = null;
                    n["overallSituation"] = "1";
                }
            })
        } else {
            n["overallSituation"] = n.overallSituation != "" || (n.id && n.id.length > 0) ? "0" : "";
            getFonts.forEach(c => {
                if (c.index == i) {
                    let _no = (!c.id || c.id.length <= 0) && !c.overallSituation; //清除
                    //保留
                    n["fileUrl"] = _no ? "" : c.fileUrl;
                    n["name"] = _no ? "" : c.name;
                    n["id"] = c.id || [];
                    n["thickeningNumber"] = null;
                    n["overallSituation"] = _no ? "" : "0";
                }
            })
        }
    })
}

//根据计价详情获取工艺数组
const getSurfaceTreatmentField = (v) => {
    var surfaceTreatmentField = [];
    for (let i = 0; i < v.priceDetailInfo.length; i++) {
        let n = v.priceDetailInfo[i],
            indexStr = '',
            index = i + 1 + '：';
        if ((n.name == '' || n.name == '无') && (n.thickeningNumber == '' || n.thickeningNumber == undefined)) continue;
        if (n.name == '' || n.name == '无' && n.thickeningNumber != '' && n.thickeningNumber != undefined) {
            indexStr += index + n.thickeningNumber;
        } else if (n.name != '' && n.name != '无' && (n.thickeningNumber == '' || n.thickeningNumber == undefined)) {
            indexStr += index + n.name;
        } else if (n.name != '' && n.name != '无' && n.thickeningNumber != '' && n.thickeningNumber != undefined) {
            indexStr += index + n.name + '，' + n.thickeningNumber;
        }
        surfaceTreatmentField.push(indexStr);
    }
    return surfaceTreatmentField;
}

//子订单报价项处理成字符串格式展示
const getQuotation = (v) => {
    let productItemInfo = typeof v == 'string' ? JSON.parse(v) : v,
        strList = [],
        expensePrice = 0, //总的价格系数
        ids = [], //对应选中的id数组
        idPrice = [];

    productItemInfo.forEach(n => {
        let { selectId, name } = n || {}, [parentId, childrenId] = selectId || [];

        if (childrenId || parentId) {
            ids.push(childrenId || parentId);
        }
        n.children.forEach(m => {
            let { value, children, id, price } = m || {};
            if (selectId && selectId.length > 0) {
                let html = "";
                if (parentId == id) {
                    html = name + "：" + value;
                    expensePrice += (price || 1) - 1;
                    idPrice.push({
                        id: id,
                        price: price || null
                    })
                }
                if (childrenId && children) {
                    children.forEach(g => {
                        let { id, value } = g || {};
                        if (childrenId == id) {
                            html += "/" + value;
                        }
                    });
                }
                if (html != "") {
                    strList.push(html);
                }
            }
        });
    })

    return {
        str: strList.length > 0 ? strList.join("; ") : "无",
        expensePrice: expensePrice, //总的报价项价格系数
        ids: ids, //最后选中ID数组
        idPrice: idPrice.length > 0 ? idPrice : [] //[{id: price}]
    }
}

//根据坐标截取canvas并生成file格式
const getCanvasCutImg = (nodeId, x1, y1, w, h, index) => {
    var canvas = document.createElement('canvas'),
        cxt = canvas.getContext("2d"),
        mainCxt = nodeId.getContext("2d"),
        dataImg = mainCxt.getImageData(x1, y1, w, h);

    canvas.width = w;
    canvas.height = h;
    cxt.putImageData(dataImg, 0, 0, 0, 0, w, h);
    let base64 = canvas.toDataURL("image/png"),
        imgFile = blobToFile(base64, index + 1);

    return imgFile;
}

//获取当前时间
import * as API from "@/api/index.js";
const getNewDate = () => {
        return new Promise((resolve, reject) => {
            API.queryCurrentTime().then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    }
    //字体编号排序Y轴
const fontsY = ({ data = [], success } = {}) => {
    if (data.length == 1) {
        return success && success(data);
    }
    //Y轴顶部字体降序
    data.sort((a, b) => {
        //计算保存中心点
        a['centralPoint'] = {
            x: a.x + a.width * .5,
            y: a.y + a.height * .5
        };
        b['centralPoint'] = {
            x: b.x + a.width * .5,
            y: b.y + b.height * .5
        };
        return a.y - b.y;
    });

    //中心点Y轴上下10范围内合并数组
    let lists = [];
    data.forEach(item => {
            if (item.centralPoint) {
                let items = data.filter(n => {
                    /**
                     * 计算规则
                     * 已一个字体为参考，在基准字体的上下边范围内
                     * 或其它计算字体的中心点对比参考字体的上边下边有一个相差5范围内
                     */
                    if (n.centralPoint && (n.centralPoint.y >= item.y && n.centralPoint.y <= item.y + item.height || Math.abs(n.centralPoint.y - item.y) <= 5 || Math.abs(n.centralPoint.y - (item.y + item.height)) <= 5)) {
                        delete n.centralPoint;
                        return true;
                    }
                    return false;
                });

                if (items && items.length > 0) {
                    //将同组按X轴从左往右排列
                    items.sort((a, b) => {
                        return a.x - b.x;
                    })
                    lists = [...lists, ...items];
                }
            }
        })
        //去重
    lists = [...new Set(lists)];

    success && success(lists || []);
}

export default {
    loading,
    message,
    timestamp,
    getDate,
    systemDate,
    setCookie,
    getCookie,
    clearCookie,
    convertBase64UrlToBlob,
    dataURLtoFile,
    blobToFile,
    disableDate,
    echoDate,
    getDays,
    timeDown,
    setCanvas,
    getSurfaceTreatmentField,
    arraySort,
    getQuotation,
    canvasClick,
    alterFonts,
    getCanvasCutImg,
    getNewDate,
    fontsY,
}


// WEBPACK FOOTER //
// ./src/api/utils.js